import React from 'react';
import FormVitrine from '../vitrines/FormVitrine';

// A data final alimenta o contador, por isso o agendamento é obrigatório.
const VitrineComCronometro: React.FC = () => (
  <FormVitrine agendamentoObrigatorio />
);

export default VitrineComCronometro;
